<app-feed-detail-panel *ngIf="isAuthenitcated && !loading" [fullscreen]="true"></app-feed-detail-panel>

<div class="loader-container" *ngIf="loading">
    <app-ltms-loader></app-ltms-loader>
</div>